import angular from 'angular';
import moment from 'moment';

angular
  .module('cloudX')
  .controller('VisionPlannerCreateAdministrationDialogCtrl', [
    '$http',
    'appUrls',
    'flySvc',
    '$filter',
    '$q',
    '$element',
    'dataCache',
    'close',
    'relationId',
    visionPlannerCreateAdministrationDialogCtrl,
  ]);

function visionPlannerCreateAdministrationDialogCtrl(
  $http,
  appUrls,
  flySvc,
  $filter,
  $q,
  $element,
  dataCache,
  close,
  relationId,
) {
  var vm = this;
  vm.saving = false;
  vm.model = {
    compilationSubscription: 'CompilationNone',
    insightsSubscription: 'InsightsNone',
    templateName: undefined,
    periodType: 'month',
  };

  vm.save = function() {
    if (vm.saving) return '';

    vm.saving = true;
    vm.error = null;
    $http.post(`${appUrls.api}/api/relation/visionplanner/${relationId}`, vm.model).then(
      function(result) {
        flySvc.success();
        $element.modal('hide');
        close(null, 500);
      },
      ({ data }) => {
        vm.saving = false;
        if (data.code === 1304) {
          vm.exists = true;
          vm.administrationId = data.parameters[0];
        } else if (data.code === 1305) {
          vm.error = data.parameters[0];
          flySvc.error(data);
        } else {
          flySvc.error(data);
        }
      },
    );
  };

  vm.storeReference = function() {
    if (vm.saving) return '';
    vm.saving = true;

    $http
      .post(`${appUrls.api}/api/relation/visionplanner/${relationId}/${vm.administrationId}`)
      .then(
        function(result) {
          flySvc.success();
          $element.modal('hide');
          close(null, 500);
        },
        error => {
          vm.saving = false;
        },
      );
  };

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };
}
